import * as React from "react";
import { IAutoWizardModel } from "../interfaces/IAutoWizardModel";
import { updateDataLayerVehicleVariable, updateDataLayerFirstName } from "../common/Utils";
import { saveResumeDataInLocalStorage } from "../common/Utils";

declare var awl: any;

export class SavePrimaryVehicleData extends React.Component<{ model: IAutoWizardModel }, {}> {

    constructor(props: any) {
        super(props);
    }

    componentDidMount(): void {
        const resumeActionName: string = window.location.hash;

        updateDataLayerVehicleVariable(this.props.model.primaryVehicle.year,
            this.props.model.primaryVehicle.make,
            this.props.model.primaryVehicle.model);

        if (this.props.model.primaryVehicle.year != null &&
            this.props.model.primaryVehicle.make != null &&
            this.props.model.primaryVehicle.model != null) {

            saveResumeDataInLocalStorage(this.props.model, resumeActionName);
        }
    }

    render(): JSX.Element {

        return null;
    }
}

export class SaveAdditionalVehicleData extends React.Component<{ model: IAutoWizardModel }, {}> {

    constructor(props: any) {
        super(props);
    }

    componentDidMount(): void {
        const resumeActionName: string = window.location.hash;

        if (this.props.model.additionalVehicles[0].year != null &&
            this.props.model.additionalVehicles[0].make != null &&
            this.props.model.additionalVehicles[0].model != null) {

            saveResumeDataInLocalStorage(this.props.model, resumeActionName);
        }
    }

    render(): JSX.Element {

        return null;
    }
}

export class SavePrimaryDriverData extends React.Component<{ model: IAutoWizardModel }, {}> {

    constructor(props: any) {
        super(props);
    }

    componentDidMount(): void {
        const resumeActionName: string = window.location.hash;

        if (this.props.model.primaryDriver.licenseStatus != null &&
            this.props.model.primaryDriver.filingRequired != null &&
            this.props.model.primaryDriver.gender != null &&
            this.props.model.primaryDriver.married != null) {

            saveResumeDataInLocalStorage(this.props.model, resumeActionName);
        }
    }

    render(): JSX.Element {

        return null;
    }
}

export class SavePrimaryDriverBirthDateData extends React.Component<{ model: IAutoWizardModel }, {}> {

    constructor(props: any) {
        super(props);
    }

    componentDidMount(): void {
        const resumeActionName: string = window.location.hash;

        if (this.props.model.primaryDriver.birthMonth != null &&
            this.props.model.primaryDriver.birthDay != null &&
            this.props.model.primaryDriver.birthYear != null) {

            saveResumeDataInLocalStorage(this.props.model, resumeActionName);
        }
    }

    render(): JSX.Element {

        return null;
    }
}

export class SaveApplicantInfoData extends React.Component<{ model: IAutoWizardModel }, {}> {

    constructor(props: any) {
        super(props);
    }

    componentDidMount(): void {
        const resumeActionName: string = window.location.hash;

        if (this.props.model.applicantInfo.creditRating != null &&
            this.props.model.applicantInfo.currentResidence != null &&
            this.props.model.applicantInfo.isMilitary != null) {

            saveResumeDataInLocalStorage(this.props.model, resumeActionName);
        }
    }

    render(): JSX.Element {

        return null;
    }
}

export class SaveIncidentsData extends React.Component<{ model: IAutoWizardModel }, {}> {

    constructor(props: any) {
        super(props);
    }

    componentDidMount(): void {
        const resumeActionName: string = window.location.hash;

        if (this.props.model.atFaultAccidentInThePastThreeYears != null &&
            this.props.model.twoOrMoreTicketsInThePastThreeYears != null &&
            this.props.model.duiConvictionInThePastThreeYears != null) {

            saveResumeDataInLocalStorage(this.props.model, resumeActionName);
        }
    }

    render(): JSX.Element {

        return null;
    }
}

export class SaveCurrentInsuranceData extends React.Component<{ model: IAutoWizardModel }, {}> {

    constructor(props: any) {
        super(props);
    }

    componentDidMount(): void {
        const resumeActionName: string = window.location.hash;

        if (this.props.model.currentInsurance.currentlyInsured != null &&
            this.props.model.currentInsurance.insuredSince != null &&
            this.props.model.currentInsurance.insuranceCarrier) {

            saveResumeDataInLocalStorage(this.props.model, resumeActionName);
        }
    }

    render(): JSX.Element {

        return null;
    }
}

export class SaveHomeAddonData extends React.Component<{ model: IAutoWizardModel }, {}> {

    constructor(props: any) {
        super(props);
    }

    componentDidMount(): void {

        const resumeActionName: string = window.location.hash;

        if (this.props.model.homeAddon.bundle != null &&
            this.props.model.homeAddon.propertyType != null &&
            this.props.model.homeAddon.yearBuilt != null &&
            this.props.model.homeAddon.anyClaims != null) {

            saveResumeDataInLocalStorage(this.props.model, resumeActionName);
        }
    }

    render(): JSX.Element {

        return null;
    }
}

export class SaveContactInfoNameData extends React.Component<{ model: IAutoWizardModel }, {}> {

    constructor(props: any) {
        super(props);
    }

    componentDidMount(): void {
        const resumeActionName: string = window.location.hash;
        updateDataLayerFirstName(this.props.model.contactInfo.firstName);

        if (this.props.model.contactInfo.firstName != null &&
            this.props.model.contactInfo.lastName != null &&
            this.props.model.contactInfo.email != null) {

            saveResumeDataInLocalStorage(this.props.model, resumeActionName);
        }
    }

    render(): JSX.Element {

        return null;
    }
}

export class SaveAdditionalDriverData extends React.Component<{ model: IAutoWizardModel }, {}> {

    constructor(props: any) {
        super(props);
    }

    componentDidMount(): void {
        const resumeActionName: string = window.location.hash;

        if (this.props.model.hasAdditionalDriver != null &&
            this.props.model.additionalDriver.birthYear != null &&
            this.props.model.additionalDriver.birthMonth != null &&
            this.props.model.additionalDriver.birthDay != null &&
            this.props.model.additionalDriver.lastName != null &&
            this.props.model.additionalDriver.firstName != null) {

            saveResumeDataInLocalStorage(this.props.model, resumeActionName);
        }
    }

    render(): JSX.Element {

        return null;
    }
}